import request from '@/utils/request'
const apiPath = '/sys/sysGoodsSpecValuecombine'
const sysGoodsSpecValuecombineApi = {
  /**
   * 新增【商品规格组合】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【商品规格组合】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【商品规格组合】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查看【商品规格组合】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【商品规格组合】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 批量删除【商品规格组合】
   */
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  },
  updateDeleted(data) {
    return request.post(apiPath + '/updateDeleted', data, { isFormData: 1 })
  },
}
export default sysGoodsSpecValuecombineApi
